(function(){
  if (window.__ostInit) return;
  window.__ostInit = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n){ return String(n).padStart(2,'0'); }
  function root(){ return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  function startClocks(){
    var clocks = document.querySelectorAll('[data-ost-clock]');
    if (!clocks.length) return;
    function tick(){
      clocks.forEach(function(el){
        var end;
        var iso = el.getAttribute('data-ost-deadline');
        if (iso) { end = new Date(iso); }
        if (!end || isNaN(end.getTime()) || end - new Date() <= 0) {
          end = new Date(); end.setHours(24,0,0,0);
        }
        var s = Math.max(0, Math.floor((end - new Date())/1000));
        el.textContent = pad(Math.floor(s/3600)) + ':' + pad(Math.floor(s%3600/60)) + ':' + pad(s%60);
      });
    }
    tick(); setInterval(tick, 1000);
  }

  function startReveals(){
    var els = [].slice.call(document.querySelectorAll('.ost-rv'));
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function(x){ x.classList.add('ost-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(t){
        if (!t.isIntersecting) return;
        var sibs = [].slice.call(t.target.parentNode.children).filter(function(c){
          return c.classList.contains('ost-rv');
        });
        t.target.style.transitionDelay = (Math.min(sibs.indexOf(t.target), 4) * 90) + 'ms';
        t.target.classList.add('ost-in');
        io.unobserve(t.target);
      });
    }, { threshold: .14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function(x){ io.observe(x); });
  }

  function startCounts(){
    var stats = [].slice.call(document.querySelectorAll('[data-ost-count]'));
    stats.forEach(function(s){
      var target = parseInt(s.getAttribute('data-ost-count'), 10);
      if (isNaN(target)) return;
      if (reduce) { s.textContent = target.toLocaleString(); return; }
      var t0 = null, dur = 1500;
      function step(ts){
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        s.textContent = Math.floor(target * e).toLocaleString();
        if (p < 1) requestAnimationFrame(step); else s.textContent = target.toLocaleString();
      }
      setTimeout(function(){ requestAnimationFrame(step); }, 350);
    });
  }

  /* ---------- cart ---------- */

  var DRAWER_SECTION = 'cart-drawer-section';
  var ADD_SELECTOR = '[data-ost-add], button[name="add"]';

  function updateBubble(count){
    document.querySelectorAll('.cart-bubble').forEach(function(b){
      if (count > 0) b.classList.remove('visually-hidden');
    });
    document.querySelectorAll('.cart-bubble__text-count').forEach(function(c){
      c.textContent = count;
      if (count > 0) c.classList.remove('hidden');
    });
    var live = document.querySelector('[data-testid="cart-count-live-region"]');
    if (live) live.textContent = count;
  }

  function placeCartExtras(){
    var summary = document.querySelector('.cart-drawer__summary');
    document.querySelectorAll('[data-ost-cart-extras]').forEach(function(x){
      if (summary && x.parentNode !== summary) summary.insertBefore(x, summary.firstChild);
      x.hidden = false;
    });
  }

  function refreshDrawer(){
    var host = document.getElementById('shopify-section-' + DRAWER_SECTION);
    if (!host) return Promise.resolve();
    return fetch(root() + '?sections=' + DRAWER_SECTION)
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(data){
        if (!data || !data[DRAWER_SECTION]) return;
        var doc = new DOMParser().parseFromString(data[DRAWER_SECTION], 'text/html');
        var fresh = doc.getElementById('shopify-section-' + DRAWER_SECTION) || doc.body.firstElementChild;
        if (fresh) host.innerHTML = fresh.innerHTML;
        placeCartExtras();
      })
      .catch(function(){});
  }

  function openDrawer(){
    var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger) { trigger.click(); setTimeout(placeCartExtras, 60); return true; }
    var comp = document.querySelector('cart-drawer-component');
    var drawer = comp && comp.closest ? comp.closest('theme-drawer') : null;
    if (drawer && typeof drawer.open === 'function') { drawer.open(); setTimeout(placeCartExtras, 60); return true; }
    return false;
  }

  function handleSubmit(e){
    var form = e.currentTarget;
    var submitter = e.submitter;

    // Shop Pay / Apple Pay / Google Pay share this form and go straight to
    // checkout — never intercept those.
    if (submitter && !submitter.matches(ADD_SELECTOR)) return;

    e.preventDefault();
    var btn = (submitter && submitter.matches(ADD_SELECTOR))
      ? submitter
      : form.querySelector(ADD_SELECTOR) || form.querySelector('button[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy','true'); btn.textContent = 'Adding…'; }

    // Ticked add-ons become extra line items in the same request.
    var addons = [].slice.call(form.querySelectorAll('[data-ost-addon]')).filter(function(a){ return a.checked; });
    var request;

    if (addons.length) {
      var idEl  = form.querySelector('input[name="id"]');
      var qtyEl = form.querySelector('input[name="quantity"]');
      var items = [{
        id: Number(idEl && idEl.value),
        quantity: Number(qtyEl && qtyEl.value) || 1
      }];
      addons.forEach(function(a){
        items.push({ id: Number(a.getAttribute('data-ost-addon')), quantity: 1 });
      });
      request = fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    } else {
      request = fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
    }

    request
      .then(function(res){
        return res.json().then(function(body){
          if (!res.ok) throw new Error(body.description || body.message || 'Could not add to cart');
          return body;
        });
      })
      .then(function(){
        return fetch(root() + 'cart.js', { headers: { 'Accept':'application/json' } })
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(cart){ if (cart) updateBubble(cart.item_count); });
      })
      .then(refreshDrawer)
      .then(function(){
        var opened = openDrawer();
        if (btn) {
          btn.disabled = false; btn.removeAttribute('aria-busy');
          btn.textContent = 'Added';
          setTimeout(function(){ btn.textContent = label; }, 1600);
        }
        if (!opened) window.location.href = root() + 'cart';
      })
      .catch(function(err){
        if (btn) {
          btn.disabled = false; btn.removeAttribute('aria-busy');
          btn.textContent = (err && err.message) ? err.message : 'Try again';
          setTimeout(function(){ btn.textContent = label; }, 2600);
        }
      });
  }

  function bindCartForms(){
    document.querySelectorAll('.ost form[action*="/cart/add"]').forEach(function(form){
      if (form.dataset.ostBound) return;
      form.dataset.ostBound = '1';
      form.addEventListener('submit', handleSubmit);
    });
  }

  // Shipping-protection toggle in the drawer. Delegated, so it survives
  // the drawer re-rendering.
  document.addEventListener('change', function(e){
    var cb = e.target && e.target.closest ? e.target.closest('[data-ost-protect]') : null;
    if (!cb) return;
    var id = Number(cb.getAttribute('data-variant'));
    var wanted = cb.checked;
    cb.disabled = true;
    var req = wanted
      ? fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
      : fetch(root() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: String(id), quantity: 0 })
        });
    req.then(function(r){ if (!r.ok) throw new Error('cart'); })
      .then(function(){
        return fetch(root() + 'cart.js', { headers: { 'Accept':'application/json' } })
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(c){ if (c) updateBubble(c.item_count); });
      })
      .then(refreshDrawer)
      .catch(function(){ cb.checked = !wanted; })
      .then(function(){ cb.disabled = false; });
  });

  function init(){ startClocks(); startReveals(); startCounts(); bindCartForms(); placeCartExtras(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function(){
    window.__ostInit = false; init(); window.__ostInit = true;
  });
  document.addEventListener('click', function(e){
    if (e.target && e.target.closest && e.target.closest('[data-testid="cart-drawer-trigger"]')) {
      setTimeout(placeCartExtras, 60);
    }
  });
})();
